import { Button, Dialog } from "@material-ui/core";
import styles from "./Announcement.module.scss";
import Clear from "@material-ui/icons/Clear";
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import AnnouncementClient from "../../../shared/clients/AnnouncementClient";
import WarningIcon from "../../../imgs/warning.svg";
import { withTranslation } from "react-i18next";

const StyledDialog = withStyles({
  paper: {
    width: 600,
    maxWidth: 600,
  },
})(Dialog);

const AnnouncementDialogDelete = ({
  user,
  id,
  closeModal,
  getAnnouncements,
  open,
  t,
}) => {
  const handleDelete = () => {
    AnnouncementClient.deleteAnnouncement(user, id)
      .then(() => {
        closeModal();
        getAnnouncements();
      })
      .catch(() => {});
  };

  return (
    <StyledDialog open={open}>
      <div className={styles.wrapper}>
        <button className={styles.close} onClick={closeModal}>
          <Clear />
        </button>
        <div className={`${styles.header} ${styles.redText}`}>
          <img src={WarningIcon} className={styles.headerIcon} />
          {t("Announcement.deleteDialogTitle")}
        </div>
        <div className={styles.buttonRowContainer}>
          <Button className={styles.cancelledDialogButton} onClick={closeModal}>
            {t("Announcement.cancelBtn")}
          </Button>
          <Button className={styles.actionBtn} onClick={handleDelete}>
            {t("Announcement.confirmBtn")}
          </Button>
        </div>
      </div>
    </StyledDialog>
  );
};

export default withTranslation("emp")(AnnouncementDialogDelete);
